import { LottiePlayer } from '@repo/ui';
import { FC, useEffect, useState } from 'react';
import { graphql, useFragment } from 'react-relay';

import { RetryBanner$key } from '@/__generated__/RetryBanner.graphql';
interface Props {
  fragmentRef: RetryBanner$key;
}
type RetryBannerProps = Props;

const RetryBanner: FC<RetryBannerProps> = ({ fragmentRef }) => {
  const data = useFragment<RetryBanner$key>(
    graphql`
      fragment RetryBanner on Query {
        bznavRefund {
          user {
            indis {
              refundStatus
            }
            corps {
              refundStatus
            }
            tritxIndis {
              refundStatus
            }
          }
          imputedYear {
            indis
            corps
          }
        }
      }
    `,
    fragmentRef
  );
  const [imputedYear, setImputedYear] = useState('');

  useEffect(() => {
    const indis = data?.bznavRefund?.user?.indis;
    const tritxIndis = data?.bznavRefund?.user?.tritxIndis;
    const corps = data?.bznavRefund?.user?.corps;
    if (
      indis?.find((item: { refundStatus: string }) => item.refundStatus === 'Retry') ||
      tritxIndis?.find((item: { refundStatus: string }) => item.refundStatus === 'Retry')
    ) {
      setImputedYear(data?.bznavRefund?.imputedYear.indis.substring(2) ?? '23');
    }
    if (corps?.find((item: { refundStatus: string }) => item.refundStatus === 'Retry')) {
      setImputedYear(data?.bznavRefund?.imputedYear.corps.substring(2) ?? '23');
    }
  }, [data?.bznavRefund?.user?.indis, data?.bznavRefund?.user?.corps, data?.bznavRefund?.imputedYear.indis, data?.bznavRefund?.imputedYear.corps]);

  return (
    <>
      {imputedYear && (
        <div className="mb-5">
          <div className="rounded-5 bg-white">
            <div className="flex items-center justify-items-center p-5">
              <div className="h-10 w-10 shrink-0">
                <LottiePlayer src={'/lotties/alarm_dot-lottie.json'} />
              </div>
              <p className="text-15 pl-3.5 font-medium text-gray-800">
                {imputedYear}년도 환급금이 추가됐어요.
                <br />
                변경된 환급금을 다시 조회해주세요.
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RetryBanner;
